export default function SectionLabel({ index, children }: { index: string; children: string }) {
  return (
    <div className="flex items-center gap-3 meta">
      <span className="text-accent-600">{index}</span>
      <span>/</span>
      <span>{children}</span>
    </div>
  );
}